import TranslationModule from "~/common/TranslationModule";
import MergeModule from "~/common/MergeModule";
import RequestModule from "~/common/RequestModule";
import { _ } from "~/common/Utils";

const prefix = process.env.PUBLIC_URL;

const initialize = async (locale) => {
    const defaultL10n = await importL10n(locale);
    const customL10n = await RequestModule.fetchJson(`${prefix}/custom/l10n/${locale}.json`);
    const mergedL10n = customL10n ? MergeModule.cloneMerge(defaultL10n, customL10n) : defaultL10n;

    TranslationModule.initialize(locale, mergedL10n);
};

const importL10n = async (locale) => {
    return import(`~/l10n/${locale}.json`).then(value => value.default);
};

const tryInitialize = async (locale) => {
    try {
        await initialize(locale);
    }
    catch (error) {
        const defaultLocale = 'en-us';
        await initialize(defaultLocale);
        _.Settings.Override('Application.SelectedLanguage', defaultLocale);
        _.UI.Prompts().Alert().ShowPrompt({ headerText: 'OTM_LOCALE_NOT_FOUND' });
    }
}

const LocalizationManager = {
    tryInitialize
};

export default LocalizationManager;